import { Card, CardActionArea, Box } from "@mui/material";

interface PlatformTileProps {
  icon: React.ReactNode;
  selected?: boolean;
  onClick?: () => void;
}

export default function PlatformTile({
  icon,
  selected = false,
  onClick,
}: PlatformTileProps) {
  return (
    <Card
      elevation={0}
      sx={{
        border: "2px solid",
        borderColor: selected ? "primary.main" : "grey.300",
        borderRadius: "4px",
        backgroundColor: selected ? "primary.50" : "#fff",
        transition: "box-shadow 0.2s ease, border-color 0.2s ease",
        position: "relative",
        "&:hover": {
          boxShadow: "6px 6px 1px rgba(0, 0, 0, 0.12)", // right & bottom only
        },
      }}
    >
      <CardActionArea
        onClick={onClick}
        sx={{
          height: 140,
          width: 260,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            maxWidth: 200,
            maxHeight: 140,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& svg": {
              width: "100%",
              height: "auto",
            },
          }}
        >
          {icon}
        </Box>
      </CardActionArea>
    </Card>
  );
}
